import React from 'react';

import { Box, IconButton, Stack, Typography } from '@mui/material';
import { LogoutCurve } from 'iconsax-reactjs';

import { STORAGE_TOKEN_KEY } from '../../../../constants/storage-key';
import UserContext from '../../../../user-context';
import UserAvatar from '../../../UserAvatar';

interface IProps {
  isCompact?: boolean;
}

const User = React.memo(({ isCompact = false }: IProps) => {
  const { user, setUser } = React.useContext(UserContext);

  const fullName = React.useMemo(() => {
    if (!user) {
      return '';
    }

    return `${user.firstname} ${user.lastname}`;
  }, [user]);

  const handleLogout = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      localStorage.removeItem(STORAGE_TOKEN_KEY);

      setUser(null);
    },
    [setUser],
  );

  return (
    <Stack direction="row" spacing={1} justifyContent={isCompact ? 'center' : 'flex-start'}>
      <Stack justifyContent="center">
        <UserAvatar user={user!} />
      </Stack>

      {!isCompact && (
        <>
          <Typography
            variant="xl"
            sx={(theme) => ({
              color: theme.palette.secondary[900],
              fontWeight: 700,
              textWrap: 'wrap',
            })}
          >
            {fullName}
          </Typography>

          <Box>
            <IconButton onClick={handleLogout} sx={{ padding: 0, height: '20px' }}>
              <LogoutCurve size={20} color="#314053" />
            </IconButton>
          </Box>
        </>
      )}
    </Stack>
  );
});

export default User;
